const resizeObjectSuppressor = () => {
  if (process.env.REACT_APP_ENVIRONMENT?.includes('LOCAL') && typeof window !== 'undefined') {
    const shouldIgnore = (msg) => {
      return (
        typeof msg === 'string' &&
        (msg.includes('ResizeObserver loop completed with undelivered notifications') ||
          msg.includes('ResizeObserver loop limit exceeded'))
      );
    };

    const shouldIgnoreUnmountedWarning = (...args) => {
      const msg = args.length ? String(args[0]) : '';
      if (!msg.includes("Can't perform a React state update on an unmounted component")) return false;
      // Only suppress when the stack trace points to rc-overflow/antd internals
      const fullTrace = args.map(String).join(' ');
      return (
        fullTrace.includes('Overflow') ||
        fullTrace.includes('rc-overflow') ||
        fullTrace.includes('rc-menu') ||
        fullTrace.includes('rc-select')
      );
    };

    if (!window.__IGNORE_RO_ERR__) {
      window.__IGNORE_RO_ERR__ = true;

      const captureError = (e) => {
        const msg = e?.message || e?.error?.message;
        if (shouldIgnore(msg)) {
          e.preventDefault?.();
          e.stopImmediatePropagation?.();
        }
      };

      const captureRejection = (e) => {
        const reason = e?.reason;
        const msg = typeof reason === 'string' ? reason : reason?.message;
        if (shouldIgnore(msg)) {
          e.preventDefault?.();
          e.stopImmediatePropagation?.();
        }
      };

      window.addEventListener('error', captureError, true); // capture phase to beat the overlay
      window.addEventListener('unhandledrejection', captureRejection, true);

      // Filter console methods so overlay logic that hooks console.error doesn’t fire for RO noise
      const origError = console.error;
      const origWarn = console.warn;
      console.error = function (...args) {
        try {
          const msg = args && args.length ? String(args[0]) : '';
          if (shouldIgnore(msg)) return; // swallow RO noise
          if (shouldIgnoreUnmountedWarning(...args)) return; // swallow rc-overflow unmount noise
        } catch (_) {
          /* no-op */
        }
        return origError.apply(console, args);
      };
      console.warn = function (...args) {
        try {
          const msg = args && args.length ? String(args[0]) : '';
          if (shouldIgnore(msg)) return;
        } catch (_) {
          /* no-op */
        }
        return origWarn.apply(console, args);
      };

      // Also hide the overlay UI as a fallback (CRA/WDS/react-error-overlay)
      const ensureOverlayHidden = () => {
        const selectors = [
          '#webpack-dev-server-client-overlay',
          'iframe#webpack-dev-server-client-overlay',
          '#react-error-overlay',
          'iframe#react-error-overlay',
          'div[id*="overlay"]',
          'iframe[id*="overlay"]',
        ];
        const els = document.querySelectorAll(selectors.join(','));
        els.forEach((el) => {
          try {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.style.pointerEvents = 'none';
          } catch (_) {
            /* no-op */
          }
        });
      };

      const id = 'suppress-dev-overlay-style';
      if (!document.getElementById(id)) {
        const style = document.createElement('style');
        style.id = id;
        style.innerHTML = `
        #webpack-dev-server-client-overlay, iframe#webpack-dev-server-client-overlay,
        #react-error-overlay, iframe#react-error-overlay,
        div[id*="overlay"], iframe[id*="overlay"] {
          display: none !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      `;
        document.head.appendChild(style);
      }

      // MutationObserver to hide any overlay that gets (re)inserted
      const mo = new MutationObserver(() => ensureOverlayHidden());
      mo.observe(document.documentElement, {childList: true, subtree: true});
      // Run once on load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ensureOverlayHidden, {once: true});
      } else {
        ensureOverlayHidden();
      }
    }
  }
};

export default resizeObjectSuppressor;
